import { useEffect } from 'react';

/*
 * TDI-794: index.html pins html, body and #root to the window height so the
 * app shell scrolls inside a fixed frame. A print view is a document, not an
 * app screen — saved as a PDF inside that frame, only the first screenful
 * made the page and everything below was cut off, for parents and SENCOs
 * alike. While a print view is on show the frame is released, so the
 * document flows over as many pages as it needs, on screen and in print.
 * Leaving the view puts the frame back.
 */
export default function useReleasedPageFrame() {
  useEffect(() => {
    const targets = [document.documentElement, document.body,
      document.getElementById('root')].filter(Boolean);
    const prior = targets.map((el) => ({
      el,
      height: el.style.height,
      overflow: el.style.overflow,
    }));
    targets.forEach((el) => {
      el.style.height = 'auto';
      el.style.overflow = 'visible';
    });
    return () => prior.forEach(({ el, height, overflow }) => {
      el.style.height = height;
      el.style.overflow = overflow;
    });
  }, []);
}
